package com.essntl.features.service.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.essntl.features.tag.domain.model.TagModel

@Composable
fun rememberSortedTagList(
    tagList: List<TagModel>,
    selectedTagIds: Set<String>,
): List<TagModel> {
    return remember(
        tagList,
        selectedTagIds,
    ) {
        tagList
            .sortedWith(
                compareBy(
                    {
                        it.id !in selectedTagIds
                    },
                    {
                        it.name.lowercase()
                    },
                ),
            )
    }
}